import React, { memo } from 'react';
import { Box } from 'native-base';
import * as Icons from '../../../../assets/icons';
const IconMap = {
  'APPLY': {
    'Complete': /*#__PURE__*/React.createElement(Icons.ApplyComplete, null),
    'Pending': /*#__PURE__*/React.createElement(Icons.ApplyPending, null),
    'Not Started': /*#__PURE__*/React.createElement(Icons.ApplyNotStarted, null)
  },
  'SIGN DISCLOSURES': {
    'Complete': /*#__PURE__*/React.createElement(Icons.SignDisclosuresComplete, null),
    'Pending': /*#__PURE__*/React.createElement(Icons.SignDisclosuresPending, null),
    'Not Started': /*#__PURE__*/React.createElement(Icons.SignDisclosuresNotStarted, null)
  },
  'DISCLOSURES': {
    'Complete': /*#__PURE__*/React.createElement(Icons.SignDisclosuresComplete, null),
    'Pending': /*#__PURE__*/React.createElement(Icons.SignDisclosuresPending, null),
    'Not Started': /*#__PURE__*/React.createElement(Icons.SignDisclosuresNotStarted, null)
  },
  'PROCESSING': {
    'Complete': /*#__PURE__*/React.createElement(Icons.ProcessingComplete, null),
    'Pending': /*#__PURE__*/React.createElement(Icons.ProcessingPending, null),
    'Not Started': /*#__PURE__*/React.createElement(Icons.ProcessingNotStarted, null)
  },
  'SCHEDULE CLOSING': {
    'Complete': /*#__PURE__*/React.createElement(Icons.SchedulingComplete, null),
    'Pending': /*#__PURE__*/React.createElement(Icons.SchedulingPending, null),
    'Not Started': /*#__PURE__*/React.createElement(Icons.SchedulingNotStarted, null)
  },
  'DONE': {
    'Complete': /*#__PURE__*/React.createElement(Icons.DoneCompleted, null),
    'Pending': /*#__PURE__*/React.createElement(Icons.DonePending, null),
    'Not Started': /*#__PURE__*/React.createElement(Icons.DoneNotStarted, null)
  }
};
const IconResolver = props => {
  const {
    stepName,
    status
  } = props;
  return /*#__PURE__*/React.createElement(Box, {
    accessibilityLabel: `${stepName} ${status}`,
    testID: `${stepName} ${status}`,
    accessibilityRole: 'image'
  }, IconMap[stepName][status]);
};
export default /*#__PURE__*/memo(IconResolver);
//# sourceMappingURL=index.js.map